import Script from 'next/script';
import type { PageAdConfig } from 'interfaces/ads/Ad';
import type { ArcSpanPageConfig } from './entities';
import { useEffect } from 'react';
export * from './setarcSpanPageConfig';

interface ArcSpanProps {
  arcSpanPageConfig: ArcSpanPageConfig;
  pageAdConfig: PageAdConfig | undefined;
}

const ArcSpan = ({ arcSpanPageConfig, pageAdConfig }: ArcSpanProps) => {
  const arcSpanConfig = {
    ...pageAdConfig,
    host: 'fortune.com',
    ...arcSpanPageConfig,
  };

  useEffect(() => {
    window.onArcspanScriptLoad = (e) => {
      if (window.onArcspanScriptLoadCallback) {
        window.onArcspanScriptLoadCallback();
      }
    };
  }, []);
  return (
    <Script
      id='arcSpan'
      strategy='afterInteractive'
      dangerouslySetInnerHTML={{
        __html: `
                (function() {
                  try {
                    window.arcSpanPageConfig = ${JSON.stringify(arcSpanConfig)};
                    var s = document.createElement('script'), el = document.getElementsByTagName('script')[0];
                    s.async = true;
                    // Attach the event listeners to the dynamically injected script.
                    s.onload = function() {
                      if (window.onArcspanScriptLoad) {
                        window.setTimeout(() => {
                          window.onArcspanScriptLoad();
                        }, 3000);
                      }
                    };
                    s.onerror = function() {
                      if (window.onArcspanScriptError) {
                        window.onArcspanScriptError();
                      }
                    };

                    var _a = (new URL(location.href));
                    var _p = (_a.origin.replace('staging.', 'www.')) + _a.pathname.replace(/\\/$/, '');
                    s.type = 'text/javascript';
                    s.src = 'https://${process.env.ARCSPAN_ORGANIZATION_ID}.p7cloud.net/as1.js?uri=' + _p;
                    el.parentNode.insertBefore(s, el);
                  } catch (e) {
                    console.error("Error in Arcspan injector script:", e);
                    // If the injector itself fails, trigger the error callback immediately.
                    if (window.onArcspanScriptError) {
                        window.onArcspanScriptError();
                    }
                  }
                })();
              `,
      }}
    />
  );
};

export default ArcSpan;
